var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"transition":"dialog-top-transition","max-width":"600px","persistent":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('ref-o-k-e-i-table',{attrs:{"mode":'compact',"value":_vm.value},on:{"input":_vm.setValue,"onCloseWindow":_vm.doClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }